import React from 'react'
import PropTypes from 'prop-types'
import { features, exclusiveJumboID } from 'config'
import { slugify } from 'utils'
import PromotionFactory from 'factories/Promotion'
import useVariant from 'hooks/useVariant'
import { useViewportMediaQuery } from 'hooks';
import style from './style.scss' //NOSONAR
import CountriesFlag from 'components/CountriesFlag'

const ProductFlags = (props) => {
    const { stock, exclusiveJumbo, item, countryFlag } = props

    const variant = useVariant(exclusiveJumboID)
    const newVariant = variant === '1';

    const isMobile = useViewportMediaQuery(425);

    const getTags = () => {
        if (!item) return []

        const flagsData = []
        const promotions = PromotionFactory.create(item)

        promotions.map((promotion) => {
            if (!promotion.tcenco && !promotion.cencoPrime) {
                flagsData.push({
                    titleFlag: 'Oferta',
                    classFlag: 'oferta',
                })
            }
        })

        return flagsData
    }

    const tags = getTags();

    return (
        <div className='product-flags'>
            {stock && tags.map((tag, i) => (
                <span className={`product-flag ${slugify(tag.classFlag)}`} key={i}>
                    <span className="product-flag-text">{tag.titleFlag}</span>
                </span>
            ))}
            {stock && exclusiveJumbo && newVariant && (
                <span className='product-flag flag-exclusive-jumbo'>Exclusivo Jumbo</span>
            )}
            {!stock && features.personalize && (
                <span className="product-flag out-of-stock">Producto sin stock</span>
            )}
            {(stock || (!stock && !isMobile)) && <CountriesFlag countryFlag={countryFlag} plp={true}/>}

        </div>
    )
}

ProductFlags.propTypes = {
    item: PropTypes.object,
    stock: PropTypes.bool,
    exclusiveJumbo: PropTypes.string,
    countryFlag: PropTypes.string
}

export default ProductFlags
